import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColumnChooserService, FilterService, GridModule, PageService, ReorderService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { ConsultationServicesRoutingModule } from './consultation-services-routing.module';
import { ConsultationServicesComponent } from './consultation-services.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { CfssPdfViewComponent } from './cfss-pdf-view/cfss-pdf-view.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
@NgModule({
  declarations: [ConsultationServicesComponent, CfssPdfViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MyDatePickerModule,
    DropDownListAllModule,
    ConsultationServicesRoutingModule,
    NgxExtendedPdfViewerModule,
    PDFExportModule,
    PdfViewerModule,
  ],
  exports:[ConsultationServicesComponent],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService,ReorderService],
})


export class ConsultationServicesModule { }
